import { TableCell, TableRow, styled as muiStyled } from '@mui/material';
import type { MainRowProps } from './types';
import { NEW_COLORS } from '../../../../../../themes/colors/newColors';

const MainRow = muiStyled(TableRow)<MainRowProps>(
  ({ ithaserror, ithaserrormessage, collapsed }) => ({
    '&.MuiTableRow-root': {
      background:
        ithaserror === 'true'
          ? 'linear-gradient(0deg, rgba(201, 54, 0, 0.04), rgba(201, 54, 0, 0.04)), #FFFFFF'
          : collapsed === 'true'
          ? 'linear-gradient(0deg, rgba(244, 158, 0, 0.04), rgba(244, 158, 0, 0.04)), #FFFFFF'
          : '',

      borderBottom:
        ithaserror === 'true' && ithaserrormessage === 'true'
          ? '1px solid transparent'
          : ithaserror === 'true' && ithaserrormessage === 'false'
          ? `transparent`
          : collapsed === 'true'
          ? `1px solid ${NEW_COLORS.SECONDARY[500]}`
          : `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
      borderTop:
        ithaserror === 'true' && ithaserrormessage === 'true'
          ? '1px solid transparent'
          : ithaserror === 'true' && ithaserrormessage === 'false'
          ? `1px solid ${NEW_COLORS.SECONDARY[700]}`
          : collapsed === 'true'
          ? `1px solid ${NEW_COLORS.SECONDARY[500]}`
          : `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,

      '&:hover': {
        background:
          ithaserror === 'false' &&
          'linear-gradient(0deg, rgba(244, 158, 0, 0.04), rgba(244, 158, 0, 0.04)), #FFFFFF',

        borderBottom:
          ithaserror === 'true' && ithaserrormessage === 'true'
            ? '1px solid transparent'
            : ithaserror === 'true' && ithaserrormessage === 'false'
            ? `transparent`
            : `1px solid ${NEW_COLORS.SECONDARY[500]}`,
      },
    },
  }),
);

const TableCellNew = muiStyled(TableCell)(() => ({
  borderBottom: 'none',
}));

export { TableCellNew, MainRow };
